module.exports = __webpack_public_path__ + "media/images/pic/teachers/anna-sielawko-e52b4e1698d12dff58b381f059aa19b0.webp";